import React from 'react';
import noDataImage from '@src/assets/images/no-data.svg';
import { Box } from '@mui/material';
import { StyledNoDataProjectList } from './index.style';

const NoData = ({ height, noDataText }) => (
  <Box width="100%" margin="auto">
    <StyledNoDataProjectList height={height}>
      <img style={{ height: '100px' }} src={noDataImage} alt="no data" />

      {noDataText && <div className="no-data-text">{noDataText}</div>}
    </StyledNoDataProjectList>
  </Box>
);

export default NoData;
